import axios from "axios";
import { DEALER_MATRIX_FAIL, DEALER_MATRIX_REQUEST, DEALER_MATRIX_SUCCESS, FETCH_TAG_SUGGESTIONS_FAILURE, FETCH_TAG_SUGGESTIONS_REQUEST, FETCH_TAG_SUGGESTIONS_SUCCESS, INVENTORY_FABRICS_FAIL, INVENTORY_FABRICS_REQUEST, INVENTORY_FABRICS_SUCCESS, INVENTORY_FAIL, INVENTORY_LIFTSTYLE_FAIL, INVENTORY_LIFTSTYLE_REQUEST, INVENTORY_LIFTSTYLE_SUCCESS, INVENTORY_REQUEST, INVENTORY_SUCCESS, ORDER_SUBMIT_FAIL, ORDER_SUBMIT_REQUEST, ORDER_SUBMIT_SUCCESS, PRODUCT_TYPES_FAIL, PRODUCT_TYPES_REQUEST, PRODUCT_TYPES_SUCCESS } from "../../constants/OrderConstants";

//
export const fetchTagSuggestions = (query, dealerId, token) => async (dispatch) => {
    dispatch({ type: FETCH_TAG_SUGGESTIONS_REQUEST });
    try {
        const { data } = await axios.get(`${process.env.REACT_APP_DP_API}/api/dealer-portal/order/tag-suggestion`, {
            params: { query, dealerId },
            headers: { Authorization: `Bearer ${token}` }
        });
        dispatch({ type: FETCH_TAG_SUGGESTIONS_SUCCESS, payload: data });
    } catch (error) {
        dispatch({ type: FETCH_TAG_SUGGESTIONS_FAILURE, payload: error.message });
    }
};

//Fetch inventory by category
export const fetchInventoryByCategory = (productType,token) => async (dispatch) => {
    try {
      const category="Headrail"
      dispatch({ type: INVENTORY_REQUEST });
      const { data } = await axios.get(`${process.env.REACT_APP_DP_API}/api/dealer-portal/inventory/category`,{
        params:{productType,category},
        headers: { Authorization: `Bearer ${token}` }

      });
  
      dispatch({
        type: INVENTORY_SUCCESS,
        payload: data,
      });
    }  catch (error) {
      console.error('Inventory Fetch Error:', error);
      dispatch({
        type: INVENTORY_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
    
  };


  export const fetchInventoryFabric = (productType,token) => async (dispatch) => {
    try {
      const category="Fabric"
      dispatch({ type: INVENTORY_FABRICS_REQUEST });
      const { data } = await axios.get(`${process.env.REACT_APP_DP_API}/api/dealer-portal/inventory/category`,{
        params:{productType,category},
        headers: { Authorization: `Bearer ${token}` }

      });
  
      dispatch({
        type: INVENTORY_FABRICS_SUCCESS,
        payload: data,
      });
    }  catch (error) {
      console.error('Inventory Fetch Error:', error);
      dispatch({
        type: INVENTORY_FABRICS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
    
  };
//liftstyle

export const fetchInventoryLiftStyle = (productType, token) => async (dispatch) => {
  try {
    const category = "Lift_hardware,Motor";
    dispatch({ type: INVENTORY_LIFTSTYLE_REQUEST });
    
    const { data } = await axios.get(
      `${process.env.REACT_APP_DP_API}/api/dealer-portal/inventory/category`,
      {
        params: { productType, category },
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    dispatch({
      type: INVENTORY_LIFTSTYLE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    console.error("Inventory Fetch Error:", error);
    dispatch({
      type: INVENTORY_LIFTSTYLE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
//Order send to manufacturer

  export const submitOrder = (orderData, token) => async (dispatch) => {
    try {
      dispatch({ type: ORDER_SUBMIT_REQUEST });
  
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      };
  
      const { data } = await axios.post(
        `${process.env.REACT_APP_DP_API}/api/dealer-portal/order/create-order-manufacture`,
        orderData,
        config
      );
  
      dispatch({
        type: ORDER_SUBMIT_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: ORDER_SUBMIT_FAIL,
        payload: error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
      });
    }
  };

  //matrix fetching
  export const fetchDealerMatrixByProductType = (productType, token) => async (dispatch) => {
    try {
      dispatch({ type: DEALER_MATRIX_REQUEST });
      
      const { data } = await axios.get(`${process.env.REACT_APP_DP_API}/api/matrices/matrix/${productType}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      
      dispatch({
        type: DEALER_MATRIX_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      dispatch({
        type: DEALER_MATRIX_FAIL,
        payload: error.response && error.response.data.message 
          ? error.response.data.message 
          : error.message,
      });
    }
  };


  //fetching product Type for order creation
  export const getProductTypesAction = (token) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_TYPES_REQUEST });

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.get(`${process.env.REACT_APP_DP_API}/api/dealer-portal/get-product-types`, config);
    dispatch({ type: PRODUCT_TYPES_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: PRODUCT_TYPES_FAIL,
      payload: error.response && error.response.data.message
        ? error.response.data.message
        : error.message,
    });
  }
};